export const visit = (vm, at) => {
at({ "en": { "conversations-inbox-message-history": { "initial-message": { "header": "Welcome message", "headerTooltip": "A welcome message is a prompt used to invite your website visitors to start a conversation." } } } });
};